import FortnoxIntegrationSection from "./FortnoxIntegrationSection";

const FortnoxLonPage = () => <FortnoxIntegrationSection type="salary" title="Fortnox lön" />;

export default FortnoxLonPage;
